var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "telRecordDialog",
      attrs: { visible: _vm.dialogtelRecordVisible, "append-to-body": "" },
      on: {
        "update:visible": function ($event) {
          _vm.dialogtelRecordVisible = $event
        },
        close: _vm.closeView,
      },
    },
    [
      _c(
        "el-tabs",
        {
          staticStyle: { height: "350px" },
          attrs: { "tab-position": _vm.tabPosition },
          on: { "tab-click": _vm.handleTabsClick },
          model: {
            value: _vm.activeTabsValue,
            callback: function ($$v) {
              _vm.activeTabsValue = $$v
            },
            expression: "activeTabsValue",
          },
        },
        _vm._l(_vm.telRecordData, function (telRecordItem, telRecordIndex) {
          return _c(
            "el-tab-pane",
            {
              key: telRecordIndex,
              attrs: {
                name: telRecordItem.name,
                stretch: true,
                label:
                  telRecordItem.name.length > 12
                    ? telRecordItem.name.substring(0, 12) + "..."
                    : telRecordItem.name,
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { staticStyle: { "text-align": "center" } },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: telRecordItem.name,
                                    placement: "top",
                                    effect: "light",
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        width: "95%",
                                        margin: "0 auto",
                                        "text-align": "center",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            telRecordItem.name +
                                              "." +
                                              telRecordItem.path.substring(
                                                telRecordItem.path.lastIndexOf(
                                                  "."
                                                ) + 1
                                              )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm.judgeFileType(telRecordItem.path)
                                ? _c("audio", {
                                    ref: "myAudio",
                                    refInFor: true,
                                    staticStyle: {
                                      width: "95%",
                                      height: "170px",
                                    },
                                    attrs: {
                                      src: _vm.ossPath + telRecordItem.path,
                                      controls: "controls",
                                    },
                                  })
                                : _c("img", {
                                    staticStyle: {
                                      width: "160px",
                                      height: "160px",
                                      cursor: "pointer",
                                    },
                                    attrs: {
                                      src: require("@/icon/annex.svg"),
                                      fit: _vm.fit,
                                      title: telRecordItem.name,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDownload(telRecordItem)
                                      },
                                    },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }